/**
 * Whether this person's Claude connector is behind on MarketMapr's tools
 * (GET /api/api-keys → keys[].tools_stale; backend routes/mcp.js toolsHash,
 * migration 237). Drives the blue "i" on Settings in the sidebar and on the
 * Integrations tab, which goes once Claude has refreshed its tool list.
 * Checked on load and every 10 minutes; MarketMapr only; false on any error.
 */
import { useEffect, useState } from 'react';
import { IS_RECMAPPER } from '../product';

export function useClaudeToolsStale(token: string | null | undefined): boolean {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    if (!token || IS_RECMAPPER) return;
    let off = false;
    const check = () => fetch('/api/api-keys', { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!off) setStale(!!d && Array.isArray(d.keys) && d.keys.some((k: any) => k.tools_stale)); })
      .catch(() => { /* never nag on an error */ });
    check();
    const t = setInterval(check, 10 * 60 * 1000);
    return () => { off = true; clearInterval(t); };
  }, [token]);
  return stale;
}
